<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <!-- Settings Menu -->
          <leads-tabs></leads-tabs>
          <!-- /Settings Menu -->

          <div class="row">
            <individual-sidebar></individual-sidebar>

            <div class="col-xl-9 col-lg-12">
              <!-- Info -->
              <div class="card">
                <div class="card-body">
                  <form @submit.prevent="submitForm">
                    <div class="border-bottom mb-3">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">
                              Lead Name <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Lead Short Name </label>
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">
                              Primary Contact No (Mobile)
                              <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Primary Email </label>
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Project Name </label>
                            <multiselect
                              v-model="selectedProject"
                              :options="projects"
                              track-by="name"
                              label="name"
                              placeholder="Select Project"
                            >
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">
                              Prospect Assign To
                            </label>
                            <multiselect
                              v-model="selectedAssignTo"
                              :options="assignPersons"
                              track-by="name"
                              label="name"
                              placeholder="Select Assign To"
                            >
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="mb-3">
                            <label class="form-label">
                              Additional Assigned Person
                            </label>
                            <multiselect
                              v-model="selectedAdditionalAssignTo"
                              :options="assignPersons"
                              track-by="name"
                              label="name"
                              placeholder="Select Additional Assign To"
                            >
                            </multiselect>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="btn-list">
                      
                      <button type="submit" class="btn btn-primary">
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /Info -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      title: "Initial Information",
      selectedProject: {},
      projects: [
        { id: 1, name: "Project 1" },
        { id: 2, name: "Project 2" },
        { id: 3, name: "Project 3" },
      ],
      selectedAssignTo: {},
      assignPersons: [
        { id: 1, name: "Assign To 1" },
        { id: 2, name: "Assign To 2" },
        { id: 3, name: "Assign To 3" },
      ],
      selectedAdditionalAssignTo: {},
    };
  },
};
</script>
